/**
 * クライアントの外部IPアドレスを取得する。
 * api.ipify.org を使用。取得失敗時は null を返す。
 */
export const getClientIp = async (): Promise<string | null> => {
  try {
    const res = await fetch("https://api.ipify.org?format=json", {
      signal: AbortSignal.timeout(3000),
    });
    if (!res.ok) return null;
    const json = (await res.json()) as { ip?: string };
    return typeof json.ip === "string" ? json.ip : null;
  } catch {
    return null;
  }
};
